<template>
  <div class="passchange">
    <div class="passchange__container">
      <p class="passchange__container--p">
        اطلاعات رمز عبور
      </p>
      <div class="passchange__container--info">
        <div class="j3">
          <label for="">رمزعبور فعلی</label>
          <input
            type="password"
            placeholder="رمز عبور فعلی"
            class="passchange__container--info-email"
            v-model="info.oldpass"
            style="direction: ltr"
            :class="[per == false ? 'edit' : '']"
          />
        </div>
        <div class="j3">
          <label for="">رمز عبور جدید</label>
          <input
            type="password"
            placeholder="رمز عبور جدید"
            class="passchange__container--info-email"
            v-model="info.newpass"
            style="direction: ltr"
            :class="[per == false ? 'edit' : '']"
          />
        </div>
        <div class="j3">
          <label for="">تکرار رمز عبور جدید</label>
          <input
            type="password"
            placeholder="تکرار رمز عبور جدید"
            class="passchange__container--info-email"
            v-model="info.newpassc"
            style="direction: ltr"
            :class="[per == false ? 'edit' : '']"
          />
        </div>

        <button @click.prevent="send" class="passchange__container-btn">
          تغییر رمز عبور
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      per: true,
      info: {
        oldpass: "",
        newpass: "",
        newpassc: ""
      }
    };
  },
  methods: {
    send() {
      var that = this;
      this.$store.state.load = true;
      if (
        this.info.oldpass.length == 0 ||
        this.info.newpass.length == 0 ||
        this.info.newpassc.length == 0
      ) {
        that.$toastr.e("لطفا تمام فیلد هارا پر کنید.");
        that.$store.state.load = false;
      } else if (this.info.newpass.length < 8) {
        that.$toastr.e("رمز عبور باید بیشتر از ۸ رقم باشد.");
        that.$store.state.load = false;
      } else if (this.info.newpass != this.info.newpassc) {
        that.$toastr.e("رمز عبور جدید با تکرار آن یکی نیست.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/passwd/change/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile")
          },
          type: "POST",
          data: {
            current_password: this.info.oldpass,
            new_password: this.info.newpass,
            new_password_c: this.info.newpassc
          },
          success: function(data, textStatus, request) {
            that.$toastr.s(data);
          },
          error: function(request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function() {
            that.$store.state.load = false;
            that.per = true;
          }
        });
      }
    }
  },
  created() {
    this.$store.state.load = true;
    var that = this;
    that.$store.state.load = false;
  }
};
</script>
<style lang="scss" scoped>
.j1 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    width: 93%;
    background: red;
    @media screen and (max-width: 500px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j2 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    width: 96%;
    // background: red;
    // background: red;
    @media screen and (max-width: 500px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j3 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    width: 98%;
    // background: red;
    @media screen and (max-width: 500px) {
      width: 93%;
      font-size: 0.8em;
    }
  }
}
.passchange {
  width: 100%;
  height: auto;
  // background: red;
  margin-top: 7.9em;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
    font-size: 0.6em;
  }
  &__container {
    display: flex;
    flex-direction: column;
    direction: rtl;
    padding: 3em;
    justify-content: center;
    // align-items: center;
    // background: red;
    width: 60%;
    @media screen and (max-width: 1000px) {
      width: 100%;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
    }
    &-btn {
      text-decoration: none;
      border: none;
      padding: 1em;
      color: var(--main-color);
      background: var(--sub-color);
      font-family: "yekan";
      margin-top: 2em;
      border-radius: 8px;
      cursor: pointer;
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      // transform: translate(5.5%);
    }
    &--p {
      font-family: 0.9em;
      margin-bottom: 1em;
    }
    &--info {
      border-radius: 8px;
      background: var(--main-color);
      border: 1px solid rgb(194, 214, 219);
      height: auto;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.164);
      display: flex;
      flex-direction: column;
      padding: 1em;
      //   background: red
      padding: 4em;
      input {
        color: var(--font-color);
        font-family: "yekan";
        // width: auto;
        border: none;
        background: var(--bg-color);
        padding: 1em;
        margin: 1em;
        border-radius: 8px;
      }
      &-fname {
        width: 50%;
      }
      &-lname {
        width: 50%;
      }
    }
  }
}
.con7 {
  //   background: red;
  width: 100%;
  display: flex;
}
.edit {
  background: var(--main-color) !important;
  border: 1px solid var(--sub-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userDetail/passchange.vue